import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import Keycloak from 'keycloak-js';

export const publicGuard: CanActivateFn = (): boolean | UrlTree => {
  const keycloak = inject(Keycloak);
  const router = inject(Router);

  if (keycloak.authenticated) {
    return router.parseUrl('/zacetnaStran');
  }
  return true;
};
